import React from 'react'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CAMBIO_CEREAL_VALIDO } from '../../../config/tables'

function CambioCerealValidoView () {
  return (
    <MuiTable id={TABLA_CAMBIO_CEREAL_VALIDO} />
  )
}

export default CambioCerealValidoView
